import Vue from 'vue';
import { HTTP } from '@/utils/http';
import * as actions from '../types/actions';
import * as getters from '../types/getters';
import * as mutations from '../types/mutations';

const defaultStaffMember = {
  _embedded: {
    profile_image: {},
  },
};

export default {
  actions: {
    async [actions.DO_CREATE_STAFF_MEMBER]({ commit }, payload) {
      const { data } = await HTTP.post('/staff_members', payload);
      commit(mutations.SET_STAFF_MEMBER, data.data.staff_members[0]);
      return data;
    },
    async [actions.DO_DELETE_STAFF_MEMBER]({ commit }, payload) {
      const { id, ignore } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      delete params.ignore;
      const { data } = await HTTP.delete(`/staff_members/${id}`, params);
      if (!ignore) commit(mutations.SET_STAFF_MEMBER, data.data.staff_members[0]);
      return data;
    },
    async [actions.DO_GET_STAFF_MEMBER]({ commit }, payload) {
      const { id } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      const { data } = await HTTP.get(`/staff_members/${id}`, { params });
      commit(mutations.SET_STAFF_MEMBER, data.data.staff_members[0]);
      return data;
    },
    async [actions.DO_GET_STAFF_MEMBERS]({ commit }, params) {
      const { data } = await HTTP.get('/staff_members', { params });
      commit(mutations.SET_STAFF_MEMBERS, data.data.staff_members);
      return data;
    },
    async [actions.DO_UPDATE_STAFF_MEMBER]({ commit }, payload) {
      const { id } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      const { data } = await HTTP.patch(`/staff_members/${id}`, payload);
      commit(mutations.SET_STAFF_MEMBER, data.data.staff_members[0]);
      return data;
    },
  },
  getters: {
    [getters.GET_STAFF_MEMBER]: state => state.staffMember,
    [getters.GET_STAFF_MEMBERS]: state => state.staffMembers,
  },
  mutations: {
    [mutations.INSERT_STAFF_MEMBER](state, payload) {
      const index = _.findIndex(state.staffMembers, { id: payload.val.id });
      if (index >= 0) {
        state.staffMembers.splice(index, 1);
      }
      state.staffMembers.splice(payload.index, 0, payload.val);
    },
    [mutations.SET_STAFF_MEMBER](state, staffMember) {
      state.staffMember = staffMember;
    },
    [mutations.SET_STAFF_MEMBER_FIELD](state, field) {
      const nodes = field.key.split('.');
      let obj = state.staffMember;
      let i = 0;
      nodes.forEach((node) => {
        i += 1;
        if (i === nodes.length) {
          Vue.set(obj, node, field.val);
        } else {
          obj = obj[node];
        }
      });
    },
    [mutations.SET_STAFF_MEMBERS](state, staffMembers) {
      state.staffMembers = staffMembers;
    },
    [mutations.UNSET_STAFF_MEMBER](state) {
      state.staffMember = _.cloneDeep(defaultStaffMember);
    },
  },
  state: {
    staffMember: _.cloneDeep(defaultStaffMember),
    staffMembers: [],
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/staff_members.js